<template>
  <layout-auth>
    <auth-form-base>
      <h4>Registration complection</h4>
      <div class="my-1">
        Please, enter your password to complete registration.
      </div>
      <v-form>
        <v-text-field
          prepend-icon="mdi-lock"
          v-model="password"
          label="Password"
          type="password"
        ></v-text-field>
      </v-form>
      <v-container class="pa-0">
        <v-row justify="end" dense>
          <v-col cols="auto">
            <v-btn color="primary" depressed @click="submit">send</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </auth-form-base>
  </layout-auth>
</template>

<script>
import LayoutAuth from './AuthLayout';
import AuthFormBase from './AuthFormBase';
export default {
  name: 'AuthFormEnrollment',
  components: {
    LayoutAuth,
    AuthFormBase
  },
  data() {
    return {
      errorReason: '',
      user: '',
      password: '',
      error: ''
    };
  },
  methods: {
    submit() {}
  }
};
</script>
